import { Navigate } from "react-router-dom";
import { ReactNode, JSX } from "react";

interface Props {
  children: ReactNode;
}

export default function ProtectedRouteCompany({
  children,
}: Props): JSX.Element {
  const token = localStorage.getItem("token");

  // Kein Token vorhanden → zurück zum Login
  if (!token) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
}
